var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnimatePhoto = function SvgAnimatePhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF3C6",
    d: "m20.75 9.125 4.98-4.98v13.71l-4.98-4.98V18.5c0 1.348-1.113 2.52-2.52 2.52h-15c-1.347 0-2.46-1.172-2.46-2.52v-15C.77 2.152 1.883.98 3.23.98h15c1.407 0 2.52 1.172 2.52 2.52zm-2.52-.996V3.5h-15v15h15zm-9.96.351c0 1.407 1.113 2.52 2.46 2.52a2.5 2.5 0 0 0 2.52-2.52c0-1.347-1.113-2.46-2.52-2.46a2.476 2.476 0 0 0-2.46 2.46m7.5 6.797v.704H5.75v-.704c0-.996.586-1.875 1.523-2.285 1.055-.469 2.227-.762 3.457-.762s2.461.293 3.516.762c.879.41 1.524 1.29 1.524 2.285"
  })));
};
export default SvgAnimatePhoto;